import React from 'react';

export default function StatCards({ presentStudents, presentStudentsChange, absentStudents, absentStudentsChange, teachers, teachersChange }) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-4">
      {/* Present Students */}
      <div className="flex-1 bg-white rounded-2xl shadow border border-slate-100 flex items-center justify-between px-6 py-4 min-w-[220px]">
        <div>
          <div className="text-xs font-semibold text-slate-400 mb-1">Today's Present Students</div>
          <div className="text-2xl font-bold text-slate-800">{presentStudents}</div>
          <div className="text-sm font-semibold text-green-500 mt-1">{presentStudentsChange > 0 ? `+${presentStudentsChange}%` : `${presentStudentsChange}%`}</div>
        </div>
        <div className="bg-blue-600 rounded-xl p-3 flex items-center justify-center">
          {/* Present Students Icon: Group of People */}
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
            <circle cx="8" cy="10" r="3" stroke="#fff" strokeWidth="2"/>
            <circle cx="16" cy="10" r="3" stroke="#fff" strokeWidth="2"/>
            <path d="M2 20c0-2.5 3-4.5 6-4.5s6 2 6 4.5" stroke="#fff" strokeWidth="2"/>
            <path d="M10 20c0-1.5 2-2.5 4-2.5s4 1 4 2.5" stroke="#fff" strokeWidth="2"/>
          </svg>
        </div>
      </div>
      {/* Absent Students */}
      <div className="flex-1 bg-white rounded-2xl shadow border border-slate-100 flex items-center justify-between px-6 py-4 min-w-[220px]">
        <div>
          <div className="text-xs font-semibold text-slate-400 mb-1">Today's Absent Students</div>
          <div className="text-2xl font-bold text-slate-800">{absentStudents}</div>
          <div className="text-sm font-semibold text-red-500 mt-1">{absentStudentsChange > 0 ? `+${absentStudentsChange}%` : `${absentStudentsChange}%`}</div>
        </div>
        <div className="bg-blue-600 rounded-xl p-3 flex items-center justify-center">
          {/* Absent Students Icon: Prohibited Symbol (centered) */}
          <svg width="28" height="28" fill="none" viewBox="0 0 28 28">
            <circle cx="14" cy="14" r="8" stroke="#fff" strokeWidth="2"/>
            <line x1="9" y1="9" x2="19" y2="19" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
      </div>
      {/* Teachers */}
      <div className="flex-1 bg-white rounded-2xl shadow border border-slate-100 flex items-center justify-between px-6 py-4 min-w-[220px]">
        <div>
          <div className="text-xs font-semibold text-slate-400 mb-1">Teachers</div>
          <div className="text-2xl font-bold text-slate-800">{teachers}</div>
          <div className={`text-sm font-semibold mt-1 ${teachersChange > 0 ? 'text-green-500' : 'text-red-500'}`}>{teachersChange > 0 ? `+${teachersChange}%` : `${teachersChange}%`}</div>
        </div>
        <div className="bg-blue-600 rounded-xl p-3 flex items-center justify-center">
          {/* Teachers Icon: Graduation Cap */}
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
            <path d="M12 3L2 9l10 6 10-6-10-6z" stroke="#fff" strokeWidth="2"/>
            <path d="M2 9v2c0 2.5 4 4.5 10 4.5s10-2 10-4.5V9" stroke="#fff" strokeWidth="2"/>
            <path d="M6 17v2c0 1.5 3 2.5 6 2.5s6-1 6-2.5v-2" stroke="#fff" strokeWidth="2"/>
          </svg>
        </div>
      </div>
    </div>
  );
} 